<script>
    import ViewRewards from "./ViewRewards.svelte";
    import Fa from "svelte-fa";
    import { faArrowRight } from "@fortawesome/free-solid-svg-icons";

    export let milestones = [];
</script>

{#each milestones as milestone}
    <div class="milestone">
        <span>{milestone.stamp_count} Stempel</span>
        <span class="arrow"><Fa icon={faArrowRight}/></span>
        <ViewRewards rewards={milestone.rewards??[]} type={milestone.type}></ViewRewards>
    </div>
{/each}

<style>
    .milestone {
        display: flex;
        gap: 1rem;
    }
</style>